"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EventListItemView = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

var _Skeleton = require("@insided/destination/uikit/Skeleton");

var _EventAttendeesPreview = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventAttendeesPreview"));

var _Laptop = _interopRequireDefault(require("@insided/destination/icons/Laptop"));

var _Users = _interopRequireDefault(require("@insided/destination/icons/Users"));

var _EventDateFormatter = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventDateFormatter"));

var _EventListOverview = _interopRequireWildcard(require("@insided/deprecated-preact-components/Event/EventListOverview"));

var _EventSettings = require("@insided/deprecated-control/Event/event-settings/EventSettings");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Lazy-load NoImage SVG (43KB) only when needed
var NoImage = (0, _DynamicImport.default)(function () {
  return import('./NoImage.lazy');
}, {
  fallback: (0, _preact.h)(_Skeleton.RectangleSkeleton, {
    width: "200px",
    height: "100px"
  })
});

var EventListItemView = function EventListItemView(_ref) {
  var id = _ref.id,
      title = _ref.title,
      type = _ref.type,
      startAt = _ref.startAt,
      endAt = _ref.endAt,
      image = _ref.image,
      location = _ref.location,
      destinationUrl = _ref.destinationUrl,
      attendees = _ref.attendees,
      attendeeCount = _ref.attendeeCount,
      isLoggedInUserAttendee = _ref.isLoggedInUserAttendee,
      isFeatured = _ref.isFeatured,
      isFullWidth = _ref.isFullWidth,
      timeConfig = _ref.timeConfig,
      timezoneName = _ref.timezoneName;

  var _getTimeSettings = (0, _EventSettings.getTimeSettings)(timeConfig, timezoneName),
      hour12 = _getTimeSettings.hour12,
      showTimezone = _getTimeSettings.showTimezone,
      eventTimezone = _getTimeSettings.eventTimezone;

  var formattedStartAt = _EventDateFormatter.default.formatStartAtForOverviewListCustomized(startAt, hour12, showTimezone, eventTimezone);

  var isPastEvent = _EventDateFormatter.default.isPastEvent(endAt);

  var isEventEngagementEnabled = _common.common.isModuleActive('eventEngagement');

  var hrefClassName = "event-list-item__url qa-event-list-item-url qa-event-".concat(id !== null && id !== void 0 ? id : '');
  var imageDimension = _EventListOverview.isMobile ? "".concat(Math.floor(_EventListOverview.IMAGE_DIMENSION_MOBILE_WIDTH * _EventListOverview.scale), "x").concat(Math.floor(_EventListOverview.IMAGE_DIMENSION_MOBILE_HEIGHT * _EventListOverview.scale)) : "".concat(Math.floor(_EventListOverview.IMAGE_DIMENSION_DESKTOP_WIDTH * _EventListOverview.scale), "x").concat(Math.floor(_EventListOverview.IMAGE_DIMENSION_DESKTOP_HEIGHT * _EventListOverview.scale));
  var imageUrl = image === null || image === void 0 ? void 0 : image.split('attachment').join("attachment/".concat(imageDimension));

  var parsedTitle = _htmlParser.default.stripHtml(title);

  return (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(destinationUrl),
    className: hrefClassName
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('event-list-item-container', {
      'featured-event__item': isFeatured && !isFullWidth,
      'topic-view': !isFeatured
    })
  }, (0, _preact.h)("div", {
    className: "event-item-image-container"
  }, image ? (0, _preact.h)("div", {
    className: "event-item__image",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }) : (0, _preact.h)(NoImage, {
    className: "event-item__no-image"
  })), (0, _preact.h)("div", {
    className: "event-item-detail-container"
  }, (0, _preact.h)("h3", {
    className: "event-item__title"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(destinationUrl),
    className: (0, _classnames.default)('event-item__title', 'qa-event-title', 'card-widget-title')
  }, parsedTitle)), (0, _preact.h)("div", {
    className: "event-item__meta"
  }, (0, _preact.h)("div", {
    className: "separator"
  }), type && (0, _preact.h)(_EventListOverview.EventPill, {
    className: "event-detail-item__type",
    type: type,
    past: isPastEvent
  }), (0, _preact.h)("div", {
    className: "separator"
  }), (0, _preact.h)("div", {
    className: (0, _classnames.default)('event-item__date', {
      event__date_past: isPastEvent
    })
  }, formattedStartAt), (0, _preact.h)("div", {
    className: "separator"
  }), location ? (0, _preact.h)(PeopleLocation, null) : (0, _preact.h)(OnlineLocation, null), (0, _preact.h)(_EventAttendeesPreview.default, {
    isPastEvent: isPastEvent,
    attendeeCount: attendeeCount,
    attendees: attendees,
    isLoggedInUserAttendee: isLoggedInUserAttendee,
    isEventEngagementEnabled: isEventEngagementEnabled
  })))));
};

exports.EventListItemView = EventListItemView;

var OnlineLocation = function OnlineLocation() {
  return (0, _preact.h)("div", {
    className: "event-item__location"
  }, (0, _preact.h)(_Laptop.default, null), ' ', (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "events.location.online",
    m: "Forum"
  })));
};

var PeopleLocation = function PeopleLocation() {
  return (0, _preact.h)("div", {
    className: "event-item__location"
  }, (0, _preact.h)(_Users.default, {
    width: 18,
    height: 18
  }), ' ', (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "events.location.in.person",
    m: "Forum"
  })));
};

var _default = _EventListOverview.default;
exports.default = _default;